export default "__VITE_ASSET__CbdZtwQV__"